<template>
    <div class="comp-search-modal">
        <div v-for="(label, key) in search" :key="key">
            <div v-if="!label.disabled && label.label">
                <div  class="checker-out">
                    <!-- 筛选title -->
                    <h3 class="checker-label margin-bottom-10">{{label.label}}：</h3>
                    <!-- 筛选内容 -->
                    <div>
                        <span v-for="(value, index_v) in label.values"
                              :key="value.id"
                              class="checker-in"
                              :class="{active: label.selected.includes(index_v)}"
                              @click.stop="handleCheck(index_v, label)">
                            {{value.name}}
                        </span>
                    </div>
                </div>
                <!-- 2022年10月19日 新增 自定义查询过期时间 设备 -->
                <template v-if="key =='device_state'">
                    <DatePicker v-model="daterange" type="daterange" format="yyyy-MM-dd" @on-ok="confirmDate" @on-clear="clearDate" confirm  :options="endDatePickerOptions" placement="right-start" placeholder="自定义过期日期查询" style="width: 200px"></DatePicker>
                </template>
                <Divider></Divider>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "search-modal",
        props: {search: Object,searchLoading:Boolean},
        data(){
          return {
              daterange:[],
              endDatePickerOptions:{
                  shortcuts: [
                      {
                          text: '1 周',
                          value () {
                              const end = new Date();
                              const start = new Date();
                              end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
                              return [start, end];
                          }
                      },
                      {
                          text: '1 个月',
                          value () {
                              const end = new Date();
                              const start = new Date();
                              end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
                              return [start, end];
                          }
                      },
                      {
                          text: '3 个月',
                          value () {
                              const end = new Date();
                              const start = new Date();
                              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
                              return [start, end];
                          }
                      }
                  ]
              }
          }
        },
        methods: {
            //选择 条件
            handleCheck (index, label) {
              if(!this.searchLoading){
                let positionInSelected = label.selected.indexOf(index);
                if (positionInSelected === -1) {
                  label.selected.push(index);
                  if (label.handler) label.handler(true, index);
                } else {
                  label.selected.splice(positionInSelected, 1);
                  if (label.handler) label.handler(false, index);
                }
              }else{
                this.$Message.warning("操作过于频繁，请稍后...")
              }

            },
            //确定日期选择
            confirmDate(){
                let startDate = this.daterange[0].pattern("yyyy-MM-dd");
                let endDate = this.daterange[1].pattern("yyyy-MM-dd");
                this.$emit("selectedDate",[startDate,endDate]);
            },
            clearDate(){
                this.$emit("selectedDate",[]);
            }
        }
    }
</script>

<style scoped lang="less">
    .comp-search-modal {
        max-height: 100vh;overflow-y: auto;
    }

    .checker-in {
        cursor: pointer;
        display: inline-block;
        padding: 0 4px;
        margin: 5px;
        border-radius: 2px;
        font-size: 14px;
    }
    .checker-in.active {
        color: white;
    }
</style>